<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Twirl</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="cta1" id="p0005-01-0"><a id="pagev">contents</a></p><a id="pagev">
</a><p class="cct1" id="p0005-02-1"><a id="pagev"></a><a href="#/chapter2#ctn_1a" id="cnt_1a"><i>Introduction</i></a></p>
<p class="cct2" id="p0005-P-1"><a href="#/chapter3#ctn_1" id="cnt_1">1. More</a></p>
<p class="cct2" id="p0005-P-2"><span href="#/chapter4#ctn_2" id="cnt_2" title="Link target outside of Sample">2. Yes</span></p>
<p class="cct2" id="p0005-P-3"><span href="#/chapter5#ctn_3" id="cnt_3" title="Link target outside of Sample">3. Bloom</span></p>
<p class="cct2" id="p0005-P-4"><span href="#/chapter6#ctn_4" id="cnt_4" title="Link target outside of Sample">4. Decorate</span></p>
<p class="cct2" id="p0005-P-5"><span href="#/chapter7#ctn_5" id="cnt_5" title="Link target outside of Sample">5. Read</span></p>
<p class="cct2" id="p0005-P-6"><span href="#/chapter8#ctn_6" id="cnt_6" title="Link target outside of Sample">6. Rest</span></p>
<p class="cct2" id="p0005-P-7"><span href="#/chapter9#ctn_7" id="cnt_7" title="Link target outside of Sample">7. Wings</span></p>
<p class="cct2" id="p0005-P-8"><span href="#/chapter10#ctn_8" id="cnt_8" title="Link target outside of Sample">8. Laugh</span></p>
<p class="cct2" id="p0005-P-9"><span href="#/chapter11#ctn_9" id="cnt_9" title="Link target outside of Sample">9. Ponder</span></p>
<p class="cct" id="p0005-P-10"><span href="#/chapter12#ctn_10" id="cnt_10" title="Link target outside of Sample">10. Pen</span></p>
<p class="cct" id="p0005-P-11"><span href="#/chapter13#ctn_11" id="cnt_11" title="Link target outside of Sample">11. Art</span></p>
<p class="cct" id="p0005-P-12"><span href="#/chapter14#ctn_12" id="cnt_12" title="Link target outside of Sample">12. Snap</span></p>
<p class="cct" id="p0005-P-13"><span href="#/chapter15#ctn_13" id="cnt_13" title="Link target outside of Sample">13. Verily</span></p>
<p class="cct" id="p0005-P-14"><span href="#/chapter16#ctn_14" id="cnt_14" title="Link target outside of Sample">14. Dance</span></p>
<p class="cct" id="p0005-P-15"><span href="#/chapter17#ctn_15" id="cnt_15" title="Link target outside of Sample">15. Fragrance</span></p>
<p class="cct" id="p0005-P-16"><span href="#/chapter18#ctn_16" id="cnt_16" title="Link target outside of Sample">16. Brave</span></p>
<p class="cct" id="p0005-03-2"><span href="#/chapter19#ctn_17" id="cnt_17" title="Link target outside of Sample">17. Sorrow</span></p>
<p class="cct" id="p0005-P-17"><span href="#/chapter20#ctn_18" id="cnt_18" title="Link target outside of Sample">18. Bubbles</span></p>
<p class="cct" id="p0005-P-18"><span href="#/chapter21#ctn_19" id="cnt_19" title="Link target outside of Sample">19. Evergreen</span></p>
<p class="cct" id="p0005-P-19"><span href="#/chapter22#ctn_20" id="cnt_20" title="Link target outside of Sample">20. Sparrow</span></p>
<p class="cct" id="p0005-P-20"><span href="#/chapter23#ctn_21" id="cnt_21" title="Link target outside of Sample">21. Be</span></p>
<p class="cct" id="p0005-P-21"><span href="#/chapter24#ctn_22" id="cnt_22" title="Link target outside of Sample">22. Cuddle</span></p>
<p class="cct" id="p0005-P-22"><span href="#/chapter25#ctn_23" id="cnt_23" title="Link target outside of Sample">23. Verve</span></p>
<p class="cct" id="p0005-P-23"><span href="#/chapter26#ctn_24" id="cnt_24" title="Link target outside of Sample">24. Stars</span></p>
<p class="cct" id="p0005-P-24"><span href="#/chapter27#ctn_25" id="cnt_25" title="Link target outside of Sample">25. Edit</span></p>
<p class="cct" id="p0005-P-25"><span href="#/chapter28#ctn_26" id="cnt_26" title="Link target outside of Sample">26. Story</span></p>
<p class="cct1" id="p0005-P-26"><span href="#/chapter29#ctn_26a" id="cnt_26a" title="Link target outside of Sample"><i>Conclusion</i></span></p>
<p class="cct1" id="p0005-P-27"><span href="#/chapter30#ctn_26b" id="cnt_26b" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="cct1" id="p0005-P-28"><span href="#/chapter31#ctn_26c" id="cnt_26c" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="cct1" id="p0005-P-29"><span href="#/chapter32#ctn_26d" id="cnt_26d" title="Link target outside of Sample"><i>About the Author</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c384d2f8